import React from "react";

const map = {
  active: { bg: "success", text: "Active" },
  trial: { bg: "info", text: "Trial" },
  expired: { bg: "secondary", text: "Expired" },
  canceled: { bg: "danger", text: "Canceled" }
};

const SubscriptionBadge = ({ status = "active" }) => {
  const s = map[status] || map.active;
  return <span className={`badge bg-${s.bg}`}>{s.text}</span>;
};

export default SubscriptionBadge;
